import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_PATHS } from './api-paths';

export type TipoLembrete = 'MEDICAMENTO' | 'CONSULTA';
export type FiltroTipo = TipoLembrete | 'TODOS';

export interface UsuarioParceiro { usuarioUuid: string; nome: string; telefone?: string; ativo?: boolean; }
export interface LembreteParceiro {
  id: number; tipo: TipoLembrete; usuarioUuid: string; nomeUsuario: string;
  telefoneUsuario: string; titulo: string; descricao: string;
  dataInicio: string; dataFim: string | null; horario: string | null;
  horarios: string | null; diasSemana: string | null; preparacao: string;
}
export interface MedicamentoPayload {
  usuarioUuid?: string; nome: string; dosagem: string; formaFarmaceutica: string;
  vezesPorDia: number; diasSemana: string; horarios: string;
  dataInicio: string; dataTermino: string; preparacao: string;
}
export interface ConsultaPayload {
  usuarioUuid?: string; especialidade: string; nomeMedico: string;
  dataConsulta: string; horarioConsulta: string; local: string;
  agendadoPor: string; preparacao: string;
}
export interface MedicamentoDetalhe extends MedicamentoPayload { id: number; usuarioUuid: string; nomeUsuario: string; }
export interface ConsultaDetalhe extends ConsultaPayload { id: number; usuarioUuid: string; nomeUsuario: string; }

@Injectable({ providedIn: 'root' })
export class ParceiroLembretesService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}${API_PATHS.lembretes}`;
  private readonly usuariosUrl = `${environment.apiUrl}${API_PATHS.usuarios}`;

  listarUsuarios(): Observable<UsuarioParceiro[]> { return this.http.get<UsuarioParceiro[]>(this.usuariosUrl); }
  listar(usuarioUuid = '', tipo: FiltroTipo = 'TODOS'): Observable<LembreteParceiro[]> {
    let params = new HttpParams().set('tipo', tipo);
    if (usuarioUuid) params = params.set('usuarioUuid', usuarioUuid);
    return this.http.get<LembreteParceiro[]>(this.base, { params });
  }
  buscarMedicamento(id: number): Observable<MedicamentoDetalhe> {
    return this.http.get<MedicamentoDetalhe>(`${this.base}/medicamentos/${id}`);
  }
  buscarConsulta(id: number): Observable<ConsultaDetalhe> {
    return this.http.get<ConsultaDetalhe>(`${this.base}/consultas/${id}`);
  }
  criarMedicamento(payload: MedicamentoPayload): Observable<number> {
    return this.http.post<number>(`${this.base}/medicamentos`, payload);
  }
  criarConsulta(payload: ConsultaPayload): Observable<number> {
    return this.http.post<number>(`${this.base}/consultas`, payload);
  }
  atualizarMedicamento(id: number, payload: MedicamentoPayload): Observable<void> {
    return this.http.put<void>(`${this.base}/medicamentos/${id}`, payload);
  }
  atualizarConsulta(id: number, payload: ConsultaPayload): Observable<void> {
    return this.http.put<void>(`${this.base}/consultas/${id}`, payload);
  }
  excluir(tipo: TipoLembrete, id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${tipo}/${id}`);
  }
}
